module.exports = __webpack_public_path__ + "img/genere.92167e68.png";